import { render, staticRenderFns } from "./Opportunity.vue?vue&type=template&id=2bfb1578&scoped=true&"
import script from "./Opportunity.vue?vue&type=script&lang=js&"
export * from "./Opportunity.vue?vue&type=script&lang=js&"
import style0 from "./Opportunity.vue?vue&type=style&index=0&id=2bfb1578&prod&lang=css&"
import style1 from "./Opportunity.vue?vue&type=style&index=1&id=2bfb1578&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfb1578",
  null
  
)

export default component.exports